import React from 'react';
import { motion } from 'framer-motion';

const TOPMATE_URL = 'https://topmate.io/acharya_ji_ajay_l_agrawal/2021139';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center px-6 md:px-12 text-center overflow-hidden pt-32 pb-20 bg-brand-light">
      {/* Ambient background rings */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none -z-10">
        {[700, 540, 380, 220].map((size, i) => (
          <div 
            key={i}
            className="absolute rounded-full border border-brand-gold/[0.08]"
            style={{ width: size, height: size }}
          />
        ))}
        <div className="absolute w-[600px] h-[600px] rounded-full bg-brand-gold/[0.04] blur-3xl" />
      </div>

      <motion.div 
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="inline-flex items-center gap-3 px-6 py-2.5 rounded-full border border-brand-gold/30 bg-brand-gold/10 text-brand-dark text-xs md:text-sm uppercase tracking-[0.25em] font-bold mb-12 shadow-sm"
      >
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-gold opacity-60"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-brand-gold"></span>
        </span>
        Vedic Astrology & Vastu Advisory
      </motion.div>

      <motion.h1 
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.15 }}
        className="text-5xl md:text-[85px] font-serif text-brand-dark leading-[1.1] max-w-5xl mb-8"
      >
        Ancient Stars. <br className="hidden md:block" />
        <span className="italic text-brand-gold">Modern Decisions.</span>
      </motion.h1>

      <motion.p 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.28 }}
        className="text-xl md:text-2xl text-stone-700 max-w-3xl mb-6 font-medium leading-relaxed"
      >
        Acharyaji Ajay L Agarwal translates Vedic Astrology and Vastu Shastra into precise, actionable clarity for business owners and NRIs navigating important decisions.
      </motion.p>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.4 }}
        className="text-base md:text-lg text-stone-500 italic mb-14 font-medium"
      >
        No fear tactics. No vague prophecy.
      </motion.p>

      {/* Quote block */}
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.5 }}
        className="max-w-2xl mx-auto mb-14 border-l-4 border-brand-gold/60 pl-6 text-left bg-white/50 p-6 rounded-r-sm shadow-sm"
      >
        <p className="font-serif text-xl md:text-2xl text-stone-800 italic leading-relaxed">
          "People usually reach out when decisions begin to feel unusually heavy, and timing becomes difficult to understand."
        </p>
        <p className="text-xs md:text-sm uppercase tracking-widest text-brand-dark mt-4 font-bold">
          Acharyaji Ajay L Agarwal
        </p>
      </motion.div>

      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.62 }}
        className="flex flex-col sm:flex-row gap-5 w-full sm:w-auto"
      >
        <a 
          href={TOPMATE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="px-10 py-5 bg-brand-dark text-brand-light rounded-sm font-bold text-lg hover:bg-brand-gold transition-all duration-400 shadow-xl shadow-brand-dark/20 tracking-wide text-center"
        >
          Book Consultation — $42
        </a>
        <a 
          href="#reflect"
          className="px-10 py-5 bg-white border-2 border-stone-200 text-brand-dark rounded-sm font-bold text-lg hover:border-brand-gold hover:bg-brand-accent transition-all duration-400 tracking-wide text-center"
        >
          Reflect Before You Decide
        </a>
      </motion.div>

      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2, delay: 1 }}
        className="mt-24 flex flex-wrap justify-center gap-8 md:gap-12"
      >
        {['10,000+ Charts Read', '15+ Countries', '30 Years of Practice', 'Business & Vastu Specialist'].map((item, i) => (
          <div key={i} className="flex items-center gap-3">
            <span className="w-1.5 h-1.5 rounded-full bg-brand-gold inline-block"></span>
            <span className="text-stone-600 text-sm md:text-base uppercase tracking-widest font-bold">{item}</span>
          </div>
        ))}
      </motion.div>
    </section>
  );
}